import { GenerationConfig } from '../constants';

const texts = {
  configLabels: {
    [GenerationConfig.ClientLevel]: 'Client fitness level',
    [GenerationConfig.SessionDuration]: 'Session duration',
    [GenerationConfig.ExerciseFormat]: 'Exercise format',
    [GenerationConfig.PerformedLocation]: 'Performed location',
    [GenerationConfig.IntensityLevel]: 'Intensity level',
    [GenerationConfig.WorkoutStyle]: 'Workout style',
    [GenerationConfig.FocusAreas]: 'Focus areas',
    [GenerationConfig.AccessibleEquipment]: 'Accessible equipment',
    [GenerationConfig.Limitations]: 'Limitations',
  },
  placeholders: {
    [GenerationConfig.WorkoutStyle]: 'HIIT, circuit training, strength, endurance, yoga, etc.',
    [GenerationConfig.FocusAreas]: 'Upper body, core, lower body, full body, etc.',
    [GenerationConfig.AccessibleEquipment]: 'Dumbbells, bands, bodyweight, gym equipment, etc.',
    [GenerationConfig.Limitations]: 'Injuries, pain, movements to avoid',
  },
};

export default texts;
